import { DROPDOWN_SIZE, DROPDOWN_VARIANT, MENU_PLACEMENT } from './Dropdown.constants.js';

var getHeight = function getHeight(size) {
  switch (size) {
    case DROPDOWN_SIZE.TINY:
      return '1rem';
    case DROPDOWN_SIZE.SMALL:
      return '1.5rem';
    case DROPDOWN_SIZE.REGULAR:
      return '2rem';
    default:
      return '2rem';
  }
};
var getOptionPadding = function getOptionPadding(sizing, size, isGrouped) {
  var yPadding = size !== DROPDOWN_SIZE.TINY ? sizing.xtiny : '0';
  return isGrouped ? "".concat(yPadding, " ").concat(sizing.small, " ").concat(yPadding, " ").concat(sizing.medium) : "".concat(yPadding, " ").concat(sizing.small);
};
var getTypography = function getTypography(size, typography) {
  return size === DROPDOWN_SIZE.REGULAR ? typography.bodyRegular : typography.bodyMedium;
};
var getOptionBgColor = function getOptionBgColor(state, colours) {
  if (state.isSelected) {
    return colours.canvas.secondary.main;
  }
  if (state.isFocused) {
    return colours.canvas.secondary.strong;
  }
  return 'transparent';
};
var getMultiOptionBgColor = function getMultiOptionBgColor(state, colours) {
  if (state.isFocused) {
    return colours.canvas.secondary.strong;
  }
  return 'transparent';
};
var getControlBgColor = function getControlBgColor(state, variant, colours) {
  switch (true) {
    case state.menuIsOpen:
      return colours.canvas.tertiary.main;
    case variant === DROPDOWN_VARIANT.PRIMARY:
      return colours.canvas.secondary.main;
    case variant === DROPDOWN_VARIANT.SECONDARY:
      return colours.canvas.primary.main;
    default:
      return 'transparent';
  }
};
var getControlHoverBgColor = function getControlHoverBgColor(state, variant, colours) {
  switch (true) {
    case state.menuIsOpen:
      return colours.canvas.tertiary.main;
    case variant === DROPDOWN_VARIANT.PRIMARY:
    case variant === DROPDOWN_VARIANT.TERTIARY:
      return colours.canvas.secondary.strong;
    case variant === DROPDOWN_VARIANT.SECONDARY:
      return colours.canvas.primary.strong;
    default:
      return colours.canvas.secondary.strong;
  }
};
var getBorderRadius = function getBorderRadius(state, size, borderRadius, menuPlacement, control) {
  var curvedTop = "".concat(borderRadius.secondary, " ").concat(borderRadius.secondary, " 0 0");
  var curvedBottom = "0 0 ".concat(borderRadius.secondary, " ").concat(borderRadius.secondary);
  var isTopMenu = menuPlacement === MENU_PLACEMENT.TOP;
  switch (true) {
    case size === DROPDOWN_SIZE.TINY:
      return 'none';
    case state.menuIsOpen && !isTopMenu && control:
      return curvedTop;
    case state.menuIsOpen && isTopMenu && control:
      return curvedBottom;
    case !isTopMenu && !control:
      return curvedBottom;
    case isTopMenu && !control:
      return curvedTop;
    default:
      return borderRadius.primary;
  }
};

export { getBorderRadius, getControlBgColor, getControlHoverBgColor, getHeight, getMultiOptionBgColor, getOptionBgColor, getOptionPadding, getTypography };
//# sourceMappingURL=Dropdown.utils.js.map
